import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './assets/css/index.css'
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(<App />, document.getElementById('root'));
